import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import {
  CompareArrows as SpreadIcon,
  Functions as FunctionsIcon,
} from "@mui/icons-material";
import { FILTER_HINT } from "./averagesShared";

const ActionButton = ({ icon, label, tooltip, disabled, selected, onClick }) => (
  <Tooltip title={disabled ? FILTER_HINT : tooltip}>
    <span>
      <Button
        size="small"
        variant={selected ? "contained" : "outlined"}
        startIcon={icon}
        onClick={onClick}
        disabled={disabled}
        aria-pressed={selected}
        sx={
          selected
            ? {
                color: "#0f172a",
                fontWeight: 700,
                backgroundColor: "#e2e8f0",
                border: "1px solid #0f172a",
                "&:hover": { backgroundColor: "#cbd5e1" },
              }
            : {
                color: "#0f172a",
                borderColor: "#1e293b",
                fontWeight: 600,
                backgroundColor: "#fff",
                "&:hover": { backgroundColor: "#eef6fa", borderColor: "#1e293b" },
                "&.Mui-disabled": { color: "#94a3b8", borderColor: "#cbd5e1" },
              }
        }
      >
        {label}
      </Button>
    </span>
  </Tooltip>
);

// Two compact actions that sit in the results title bar beside Export to CSV.
// Disabled until the result is narrowed by a search or filter.
export default function AverageButtons({
  canAverage,
  securityOpen,
  onToggleSecurity,
  onOpenSpread,
}) {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
      <ActionButton
        icon={<FunctionsIcon />}
        label="Avg per Security"
        tooltip="Show the average price per security. Stays open and follows your search and filters."
        disabled={false}
        selected={securityOpen}
        onClick={onToggleSecurity}
      />
      <ActionButton
        icon={<SpreadIcon />}
        label="Avg per Spread"
        tooltip="Calculate an average spread price from a target and an acquirer"
        disabled={!canAverage}
        selected={false}
        onClick={onOpenSpread}
      />
    </Box>
  );
}
